
import type { ReactNode } from 'react';
import { Brandmark, Card, Eyebrow, Heading, Row, Stack, Text } from '@client/shared/design';
import styles from '@client/shared/design/AppStates.module.css';

interface AuthGateProps {
  eyebrow: string;
  heading: string;
  intro: ReactNode;
  children?: ReactNode;
}

// Shared scaffold for the centered, unauthenticated gate screens (sign-in, password recovery,
// onboarding, expired-link): the framed card + eyebrow/heading/brandmark header + intro copy.
// Each screen supplies its own body; omit it for a message-only card. This is the single source
// of the top-right-brandmark chrome: never re-copy the center → gate → gateCard markup.
export function AuthGate({ eyebrow, heading, intro, children }: AuthGateProps) {
  return (
    <div className={styles.center}>
      <div className={styles.gate}>
        <Card pad="lg" raised spine className={styles.gateCard}>
          <Stack gap={6}>
            <Stack gap={3}>
              <Row gap={4} align="center" justify="between">
                <Stack gap={1}>
                  <Eyebrow>{eyebrow}</Eyebrow>
                  <Heading level={2}>{heading}</Heading>
                </Stack>
                <Brandmark size={40} className={styles.headerMark} />
              </Row>
              <Text tone="soft">{intro}</Text>
            </Stack>
            {children}
          </Stack>
        </Card>
      </div>
    </div>
  );
}
